import type { RestaurantTable } from '@restaurant/api-client';

// Shared "what should we show for this table?" logic. Used by the editor
// (AdvancedTablesPage) and the read-only PlanView so they agree on a single
// display rule. The backend sometimes embeds the zone in the auto-generated
// label (e.g. "Main · 2p · #3" or the older "Main - 2-table - #3"); since the
// UI already groups tables under their zone heading, we always strip the
// zone - leaving just "2p · #3" - and only show a custom label verbatim
// (minus a redundant zone prefix if the user happened to type one).

export function autoTableNames(table: RestaurantTable, zoneLabel: string | null): string[] {
  const base = `${table.seats}p · #${table.ordinal}`;
  const dash = `${table.seats}-table - #${table.ordinal}`;
  return [base, dash, ...(zoneLabel ? [`${zoneLabel} · ${base}`, `${zoneLabel} - ${dash}`] : [])];
}

export function customLabelMinusZone(label: string, zoneLabel: string | null): string {
  if (zoneLabel && (label.startsWith(`${zoneLabel} · `) || label.startsWith(`${zoneLabel} - `))) {
    return label.slice(zoneLabel.length + 3);
  }
  return label;
}

export function tableDisplayName(table: RestaurantTable, zoneLabel: string | null): string {
  const label = table.label?.trim() ?? '';
  if (!label || autoTableNames(table, zoneLabel).includes(label)) {
    return `${table.seats}p · #${table.ordinal}`;
  }
  return customLabelMinusZone(label, zoneLabel);
}
